const ERRORS = {
  'evolution_not_configured': 'WhatsApp no está conectado. Escanea el código QR para conectar.',
  'ai_provider_not_connected': 'No hay un proveedor de IA conectado. Agrega tu clave de OpenAI o similar.',
  'plan_no_auto_reply': 'Tu plan no incluye respuestas automáticas. Contacta a soporte para activarlo.',
  'no_eligible_sellers': 'No hay vendedores marcados para recibir leads. Marca al menos uno.',
  'assignment_disabled': 'La asignación automática está desactivada.',
  'impersonation_blocked': 'Esta acción no está disponible durante impersonación.',
  'generic_403': 'No tienes permiso para esta acción.',
  'generic_error': 'Algo salió mal. Intenta de nuevo.',
};

export function translateLeadSetupError(detail) {
  if (!detail) return ERRORS.generic_error;
  const d = typeof detail === 'string' ? detail.toLowerCase() : '';
  if (d.includes('imperson')) return ERRORS.impersonation_blocked;
  if (d.includes('403') || d.includes('permiso')) return ERRORS.generic_403;
  if (d.includes('evolution') || d.includes('whatsapp')) return ERRORS.evolution_not_configured;
  if (d.includes('auto_reply') || d.includes('auto-reply')) return ERRORS.plan_no_auto_reply;
  return typeof detail === 'string' ? detail : ERRORS.generic_error;
}
